import { __assign } from "tslib";
import get from 'lodash/get';
import history from '../redux/routing/history';
import { commentOffsetParamName } from './constants';
import ddt from '@wix/da-ddt';
var logger = ddt.createLogger('comments');
var PAGE_SIZE = 20;
export function getStreamId(commentableTypeId, itemId, parentId) {
    var id = "comments:".concat(commentableTypeId, "-").concat(itemId);
    if (parentId !== undefined) {
        id = "".concat(id, "-").concat(parentId);
    }
    return id;
}
export function flatThreadToTree(comments, maxDepth) {
    // let's first find everyone's children
    var commentsById = {};
    comments.forEach(function (comment) {
        if (!comment) {
            return;
        }
        commentsById[comment.commentId] = {
            comment: comment,
            children: comments.filter(function (i) { return i && i.parentId === comment.commentId; }),
        };
    });
    var index = -1;
    // we need to recursively add children, brace yourselves
    function inlineChildrenOfChildren(comment, depth) {
        index += 1;
        var children = commentsById[comment.commentId].children;
        // safety hatch
        if (!children) {
            return __assign(__assign({}, comment), { indent: depth, index: index, isLeafComment: true });
        }
        var isLeafComment = children.length === 0 || depth >= maxDepth;
        // once we are on a leaf node, we only want to show newly posted replies
        var filteredChildren = isLeafComment
            ? // cheating a little bit here, the field is tacked on by the saga...
                children.filter(function (child) { return child.isNew; })
            : children;
        return __assign(__assign({}, comment), { indent: depth, index: index, isLeafComment: isLeafComment, children: filteredChildren.map(function (child) {
                return inlineChildrenOfChildren(child, depth + 1);
            }) });
    }
    // now let's find comments without parents present...
    var roots = comments.filter(function (comment) { return comment && (!comment.parentId || !commentsById[comment.parentId]); });
    // ...and add their happy little trees
    var forest = roots.map(function (child) { return inlineChildrenOfChildren(child, 0); });
    // aaand done, now that wasnt so bad was it
    return forest;
}
export function getCommentBoxId(commentableTypeId, commentableItemId, position) {
    return "comment-".concat(commentableTypeId, "-").concat(commentableItemId, "-").concat(position);
}
function commentToOffsetCode(_a) {
    var typeId = _a.typeId, itemId = _a.itemId, commentId = _a.commentId;
    return "".concat(typeId, ":").concat(itemId, ":").concat(commentId);
}
export function offsetCodeToCommentIds(offset) {
    var parts = offset.split(':').map(function (value) { return Number(value); });
    if (parts.length < 3 || parts.some(function (value) { return Number.isNaN(value); })) {
        return;
    }
    var typeId = parts[0], itemId = parts[1], commentId = parts[2];
    return { typeId: typeId, itemId: itemId, commentId: commentId };
}
export function getCommentCursorFromQuery(queryObject, validationIds) {
    var offset = get(queryObject, commentOffsetParamName);
    var ids = offsetCodeToCommentIds(offset && !Array.isArray(offset) ? offset : '');
    if (!ids || !ids.commentId) {
        return;
    }
    logger.log('Offset code found', ids);
    if (validationIds) {
        if (validationIds.typeId && ids.typeId !== validationIds.typeId) {
            return;
        }
        if (validationIds.itemId && ids.itemId !== validationIds.itemId) {
            return;
        }
    }
    return "".concat(ids.commentId);
}
export function updateCommentOffset(comment) {
    window.history.scrollRestoration = comment ? 'manual' : 'auto';
    var params = new URLSearchParams(history.location.search);
    params.delete(commentOffsetParamName);
    if (comment) {
        params.set(commentOffsetParamName, commentToOffsetCode(comment));
    }
    history.replace(__assign(__assign({}, history.location), { search: params.toString() }));
    logger.log('history replaced', comment ? commentToOffsetCode(comment) : 'cleared');
}
export function updateCommentOffsetEveryPage(comment, commentIndex) {
    if (commentIndex !== undefined && commentIndex % PAGE_SIZE === 0) {
        updateCommentOffset(comment);
    }
}
export function isActiveThread(typeId, itemId) {
    var params = new URLSearchParams(history.location.search);
    var offsetCode = params.get(commentOffsetParamName);
    if (!offsetCode || Array.isArray(offsetCode)) {
        return false;
    }
    var queryIds = offsetCodeToCommentIds(offsetCode);
    if (!queryIds) {
        return false;
    }
    if (itemId !== queryIds.itemId || typeId !== queryIds.typeId) {
        return false;
    }
    return true;
}
//# sourceMappingURL=helpers.js.map